import { SelectInputItem } from 'client/ui/form/input/SelectInputItem';
import { useExtraEuCountryCode } from 'common/schema/country-codes/useExtraEuCountryCode';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IHomeCountrySelectItemProps {
  name: string;
}

export function HomeCountrySelectItem(props: IHomeCountrySelectItemProps) {
  const { name } = props;
  const { t } = useTranslation();
  const { options: countrySelectOptions } = useExtraEuCountryCode();
  return (
    <SelectInputItem
      name={name}
      label={t('user.registration.form.country', 'Paese di provenienza')}
      options={countrySelectOptions}
      showSearch
      optionFilterProp="label"
      autoComplete="off-off"
    />
  );
}
